import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import Wrapper from './style';
import ExchangeTerminateMessage from '../../common/exchangeTerminate'

const { TabPane } = Tabs;

const Tab = ({
    TabList = [],
    onChange = () => { },
    activeTab = '0',
    renderTabBar = (props, DefaultTabBar) => (
        <DefaultTabBar {...props} />
    ),
    isExchangeExpired,
}) => {
    const [activeKey, setActiveTab] = useState('0');
    useEffect(() => {
        setActiveTab(activeTab);
    }, [activeTab]);
    const handleChange = (key) => {
        setActiveTab(key);
        onChange(key, TabList[key]);
    };
    return (
        <Wrapper className="tab-wrapper">
            <Tabs
                defaultActiveKey="0"
                activeKey={activeKey}
                onChange={handleChange}
                renderTabBar={renderTabBar}
                type={window.innerWidth < 550 ? "card" : 'line'}
            >
                {TabList.map((menu, id) => {
                    return (
                        <TabPane tab={menu.name} key={id}>
                            {(menu.content && parseInt(activeKey, 10) === id)
                                ?
                                <div className={isExchangeExpired && id !== 4 ? "expired-status" : ""}>{menu.content}</div>
                                : <div></div>
                            }
                            {isExchangeExpired && id !== 4 && <ExchangeTerminateMessage />}
                        </TabPane>
                    )
                })}
            </Tabs>
        </Wrapper>
    )
};

export default Tab;
